/** *********************************************
  Reducer is responsible for handling users data.
********************************************** */
import createReducer from '../utils/createReducer';
import actionTypes from '../actions/profile/actionTypes';
import {
  isCompanyAdmin,
  isSpruceAdmin,
  isAdmin,
  isTester,
  isCompanyUser,
  isSubStandard
} from '../utils/roles';


const initialState = {
  error: null
};

const fetchProfileSuccess = (state, { profile }={}) => {
  return {
    ...state,
    ...profile,
    isCompanyAdmin: isCompanyAdmin(profile.role),
    isSpruceAdmin: isSpruceAdmin(profile.role),
    isAdmin: isAdmin(profile.role),
    isTester: isTester(profile.role),
    isCompanyUser: isCompanyUser(profile.role),
    isSubStandard: isSubStandard(profile.role, profile.companySubscription),
    error: null,
  }
};

const fetchProfileError = (state, error) => ({
  ...state,
  error
});

export default createReducer(initialState, {
  [actionTypes.FETCH_PROFILE_SUCCESS]: fetchProfileSuccess,
  [actionTypes.FETCH_PROFILE_ERROR]: fetchProfileError
});



// WEBPACK FOOTER //
// src/reducers/profile.js